@for (step of steps(); track $index) {
  <div
    class="kr-step"
    [attr.data-testid]="'step' + $index"
    [class.kr-step__active]="step.value === activeStep().value"
    [class.kr-step__completed]="step.completed"
    (click)="selectStep(step)">
    @if (step.completed) {
      <fu-icon iconName="checkmark" size="16" />
    } @else {
      {{ step.value }}
    }
  </div>
  @if (step.value < steps().length) {
    <div class="kr-step__line"></div>
  }
}
